import React, { Component } from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';
import {
  Box,
  DatePicker,
  HorizontalFormControl,
} from '../../../../../../common/components';
import { Col, FormGroup, ControlLabel } from 'react-bootstrap';
import ButtonGroup from '../ReduxFormFields/ButtonGroup';

export class Indemnity extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { content, isValidDate } = this.props;
    return (
      <Box>
        <FormGroup>
          <Col sm={12}>
            <h4 className="page-title">Professional Indemnity Cover Details</h4>
          </Col>
        </FormGroup>
        {content.fields.map((field) => {
          // Compensate for previous data set using free form input field.
          if (field.name === 'data.attributes.metadata.insurer.expiry_date') {
            if (isValidDate()) {
              return (
                <FormGroup
                  controlId={field.name}
                  // className={meta && meta.touched && meta.error ? ' has-error' : ''}
                >
                  <Col sm={3}>
                    <ControlLabel>{field.label}</ControlLabel>
                  </Col>
                  <Col sm={4} md={9} className={'date-picker-field'}>
                    <Field
                      name={field.name}
                      key={field.name}
                      labelSize={3}
                      fieldSize={4}
                      dateFormat={'dd/MM/yyyy'}
                      component={DatePicker}
                      // validate={[isRequired]}
                      // showMonthYearPicker
                    />
                  </Col>
                </FormGroup>
              );
            } else {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
          }
          switch (field.type) {
            case 'currency': {
              return (
                <Field
                  key={field.name}
                  name={field.name}
                  labelSize={3}
                  fieldSize={4}
                  currency
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'input': {
              return (
                <Field
                  key={field.name}
                  name={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'date': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'question': {
              return (
                <FormGroup key={field.name}>
                  <Col sm={5}>
                    <ControlLabel>{field.label}</ControlLabel>
                  </Col>
                  <Col sm={2}>
                    <div className={'broker-application-answers'}>
                      <Field
                        name={field.name}
                        component={ButtonGroup}
                        inline
                        options={[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ]}
                      />
                    </div>
                  </Col>
                </FormGroup>
              );
            }
          }
        })}
      </Box>
    );
  }
}

export default connect((state, props) => {
  return {
    formValues: getFormValues(props.form)(state),
  };
})(Indemnity);
